import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { filterByWeek } from '../services/filters/filterByWeekAndMonth';

import WeekEvents from './WeekEvents.jsx';

import './css/EventListContent.css';

class EventListWeek extends Component {
  getWeekEvents(week) {
    let weekEvents = [];
    const weekRangeDate = moment(this.props.yearViewDate.month(this.props.currentMonth));

    // If the current month is empty don't do anything
    if (this.props.monthEvents.length !== 0) {
      weekEvents = this.props.monthEvents.filter(event => filterByWeek(event, weekRangeDate, week));

      // Sort by the starting date
      weekEvents.sort((a, b) => {
        if (moment(a.START_DATE).isSameOrBefore(moment(b.START_DATE))) { return -1; }
        return 1;
      });

      return weekEvents;
    }

    return weekEvents;
  }

  getMonthWeeks() {
    const currentMonth = this.props.yearViewDate.month(this.props.currentMonth);
    const endOfMonth = moment(currentMonth).endOf('month').endOf('isoweek');
    const oldWeekCount = moment(currentMonth).startOf('month').week();
    let startMonthWeek = moment(currentMonth).startOf('month').startOf('isoweek').add(1, 'week');
    let newWeekCount = oldWeekCount + 1;

    do {
      newWeekCount += 1;
      startMonthWeek = moment(startMonthWeek).add(1, 'week');
    } while (moment(startMonthWeek).isSameOrBefore(endOfMonth));

    return Array.from({ length: newWeekCount - oldWeekCount }, (v, i) => oldWeekCount + i);
  }

  render() {
    return (
      <div>
        {this.getMonthWeeks().map(week => (
          <WeekEvents
            key={week}
            week={week}
            weekEvents={this.getWeekEvents(week)}
            yearViewDate={this.props.yearViewDate}
            changeMapView={this.props.changeMapView}
          />
        ))}
      </div>
    );
  }
}

EventListWeek.propTypes = {
  yearViewDate: PropTypes.object.isRequired,
  currentMonth: PropTypes.string.isRequired,
  monthEvents: PropTypes.array.isRequired,
  changeMapView: PropTypes.func.isRequired
};

export default EventListWeek;



// WEBPACK FOOTER //
// ./src/components/EventListWeek.jsx